module.exports = ".edit-family-labels .btn-wrapper input {\n  margin-right: 10px;\n}\n.edit-family-labels .btn-wrapper a {\n  margin: 25px 2px 2px;\n}\n.modules-tree,\n.drivers-tree {\n  width: 50%;\n  float: left;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/familylabels/familylabels.less
// module id = ./src/app/management/components/familylabels/familylabels.less
// module chunks = main